/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newContact } from '../../../../modules/contact/actions/reducer';
import Image from '../../../Image';
import { StaticImageData } from '../../../interfaces';
import TextFields from '../../TextField/TextField';

const resetError = {
    name: {
        hasError: false,
        message: '',
    },
    email: {
        hasError: false,
        message: '',
    },
    message: {
        hasError: false,
        message: '',
    },
    api: {
        hasError: false,
        message: '',
    },
};

export default function Contact({
    className,
    background,
}: {
    className?: string;
    background: StaticImageData | string;
}): JSX.Element {
    const dispatch = useDispatch();
    const selectContacts = (state: any) => state.contacts;
    const contacts = useSelector(selectContacts);
    const [error, setError] = useState(resetError);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [values, setValues] = useState({
        name: '',
        email: '',
        message: '',
    });

    useEffect(() => {
        if (contacts) {
            setLoading(contacts.isLoading);
            if (contacts.error) {
                setError({
                    ...error,
                    api: {
                        hasError: true,
                        message: contacts.error,
                    },
                });
            }
            if (contacts.data && contacts.data.statusCode === 'CONTACT_MESSAGE_SENDED') {
                setSuccess(true);
                setValues({
                    name: '',
                    email: '',
                    message: '',
                });
            } else {
                setSuccess(false);
            }
            // console.log('contacts:', contacts, loading, success);
        }
    }, [contacts]);

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        if (values && values.message === '') {
            setError({
                ...error,
                message: {
                    hasError: true,
                    message: 'Mensaje requerido!',
                },
            });
        }

        if (values && values.email === '') {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: 'Email requerido!',
                },
            });
        } else if (values && values.email !== '' && !validateEmail(values.email)) {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: '¡Email no es valido!',
                },
            });
        }

        if (values && values.name === '') {
            setError({
                ...error,
                name: {
                    hasError: true,
                    message: 'Nombre requerido!',
                },
            });
        }

        try {
            if (values && values.email !== '' && values.name !== '' && values.message !== '' && !error.email.hasError) {
                await dispatch(newContact(values));
                setError(resetError);
            }
        } catch (e) {
            setError({
                ...error,
                api: {
                    hasError: true,
                    message: e,
                },
            });
        }
    };

    const handleChangeName = (e: any) => {
        setError({
            ...error,
            name: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, name: e.target.value });
    };

    const handleChangeEmail = (e: any) => {
        setError({
            ...error,
            email: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, email: e.target.value });
    };

    const handleChangeMessage = (e: any) => {
        setError({
            ...error,
            message: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, message: e.target.value });
    };
    return (
        <section
            className={`relative w-full flex z-20  py-24 snap-center ${className ? className : ''}`}
            role="contact"
        >
            <div className="relative z-20 w-full  sm:mx-auto mx-0 justify-center items-center text-center content-center">
                <h3 className="text-2xl font-bold italic text-white text-center mb-4 sm:mb-10">Contáctanos</h3>
                <form
                    className="flex flex-col mx-0 sm:mx-auto  text-center w-full px-4 sm:w-96"
                    onSubmit={handleSubmit}
                >
                    {success && !loading && (
                        <div className={`w-full text-center`}>
                            <p className={`text-sm text-white`}>
                                Gracias por contactarnos, pronto nos comunicaremos con usted.
                            </p>
                        </div>
                    )}
                    {loading && (
                        <div>
                            <div className=" flex justify-center items-center mpy-2  ">
                                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white"></div>
                            </div>
                            <div className=" flex justify-center items-center text-white"> Por favor Espere...</div>
                        </div>
                    )}
                    <TextFields
                        name={'name'}
                        id={'name'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Nombre'}
                        type={'text'}
                        value={values.name}
                        placeholder={'Nombre'}
                        hasError={error.name.hasError}
                        messageError={error.name.message}
                        onChange={handleChangeName}
                        background={'dark'}
                    />
                    <TextFields
                        name={'email'}
                        id={'email'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Email'}
                        type={'text'}
                        value={values.email}
                        placeholder={'Email'}
                        hasError={error.email.hasError}
                        messageError={error.email.message}
                        onChange={handleChangeEmail}
                        background={'dark'}
                    />
                    <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 pb-1 right-3"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                        <label
                            htmlFor="address"
                            className="pl-2 pointer-events-none absolute left-0 -top-3.5 text-white font-semibold text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                        >
                            Mensaje
                        </label>
                        <textarea
                            name="address"
                            id="address"
                            className={`form-input p-4 border-2 rounded-xl border-gray-300 shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none ${
                                error.message.hasError && 'ring-1 ring-red-300'
                            }`}
                            placeholder="Mensaje"
                            value={values.message}
                            onChange={handleChangeMessage}
                            rows={8}
                        />
                        {error.message.hasError && <p className="text-sm text-red-200">{error.message.message}</p>}
                    </label>
                    {error && error.api && error.api.hasError && (
                        <p className="mb-6 text-sm text-red-200">{error.api.message}</p>
                    )}

                    <button
                        className="contact-button rounded-full text-white uppercase py-4 font-extrabold bg-sm-integrate"
                        type="submit"
                    >
                        Enviar
                    </button>
                </form>
            </div>
            <Image
                className="z-0"
                src={background}
                alt="Fondo"
                layout="fill"
                objectFit="cover"
                objectPosition="center"
            />
        </section>
    );
}
